import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CalendarPageRoutingModule } from './calendar-routing.module';
import { CalendarPage } from './calendar.page';
import { NavigationTabsModule } from '../../../shared/components/navigation-tabs/navigation-tabs.module';
import { AppointmentsCardModule } from '../../../shared/components/appointments-card/appointments-card.module';
import { GetSetUpCardModule } from '../../../shared/components/get-set-up-card/get-set-up-card.module';
import { WalletCardModule } from '../../../shared/components/wallet-card/wallet-card.module';
import { TaxPlannerCardModule } from '../../../shared/components/tax-planner-card/tax-planner.module';
import { TaxToolsCardModule } from '../../../shared/components/tax-tools-card/tax-tools-card.module';
import { MarketplaceTilesModule } from '../../../shared/components/marketplace-tiles/marketplace-tiles.module';
import { AppointmentsPageModule } from '../appointments-page/appointments.module';
import { PageHeaderModule } from 'src/app/shared/components/page-header/page-header.module';
import { SecondaryHeaderModule } from 'src/app/shared/components/secondary-header/secondary-header.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CalendarPageRoutingModule,
    NavigationTabsModule,
    GetSetUpCardModule,
    WalletCardModule,
    AppointmentsCardModule,
    TaxPlannerCardModule,
    TaxToolsCardModule,
    MarketplaceTilesModule,
    AppointmentsPageModule,
    PageHeaderModule,
    SecondaryHeaderModule
  ],
  declarations: [CalendarPage]
})
export class CalendarPageModule {}
